import { APIFieldType } from '@ardoq/api-types';
import { FieldType } from './types';

export const baseAttributesMap = new Map([
  ['_id', FieldType.ID],
  ['created-by', FieldType.CREATED_BY],
  ['createdBy', FieldType.CREATED_BY],
  ['last-modified-by', FieldType.LAST_MODIFIED_BY],
  ['lastModifiedBy', FieldType.LAST_MODIFIED_BY],
  ['last-updated', FieldType.LAST_UPDATED],
  ['lastUpdated', FieldType.LAST_UPDATED],
  ['ardoq', FieldType.ARDOQ],
  ['created', FieldType.CREATED],
]);

export const defaultAttributesMap = new Map([
  ['_version', FieldType._VERSION],
  ['description', FieldType.DESCRIPTION],
  ['name', FieldType.NAME],
]);

export const componentAttributesMap = new Map([
  ['_order', FieldType._ORDER],
  ['children', FieldType.CHILDREN],
  ['color', FieldType.COLOR],
  ['component-key', FieldType.COMPONENT_KEY],
  ['createdByEmail', FieldType.CREATED_BY_EMAIL],
  ['createdByName', FieldType.CREATED_BY_NAME],
  ['createdProvenance', FieldType.CREATED_PROVENANCE],
  ['icon', FieldType.ICON],
  ['image', FieldType.IMAGE],
  ['isPublic', FieldType.IS_PUBLIC],
  ['lastModifiedByEmail', FieldType.LAST_MODIFIED_BY_EMAIL],
  ['lastModifiedByName', FieldType.LAST_MODIFIED_BY_NAME],
  ['lastProvenance', FieldType.LAST_PROVENANCE],
  ['lock', FieldType.LOCK],
  ['model', FieldType.MODEL],
  ['origin', FieldType.ORIGIN],
  ['parent', FieldType.PARENT],
  ['rootWorkspace', FieldType.ROOT_WORKSPACE],
  ['shape', FieldType.SHAPE],
  ['type', FieldType.TYPE_NAME_COMPONENT],
  ['typeId', FieldType.TYPE_ID_COMPONENT],
  ['version', FieldType.VERSION],
]);

export const referenceAttributesMap = new Map([
  ['createdByEmail', FieldType.CREATED_BY_EMAIL],
  ['createdByName', FieldType.CREATED_BY_NAME],
  ['createdProvenance', FieldType.CREATED_PROVENANCE],
  ['description', FieldType.DESCRIPTION],
  ['displayText', FieldType.DISPLAY_TEXT],
  ['lastModifiedByEmail', FieldType.LAST_MODIFIED_BY_EMAIL],
  ['lastModifiedByName', FieldType.LAST_MODIFIED_BY_NAME],
  ['lastProvenance', FieldType.LAST_PROVENANCE],
  ['lock', FieldType.LOCK],
  ['model', FieldType.MODEL],
  ['order', FieldType.ORDER],
  ['rootWorkspace', FieldType.ROOT_WORKSPACE],
  ['source', FieldType.SOURCE],
  ['sourceCardinality', FieldType.SOURCE_CARDINALITY],
  ['target', FieldType.TARGET],
  ['targetCardinality', FieldType.TARGET_CARDINALITY],
  ['targetWorkspace', FieldType.TARGET_WORKSPACE],
  ['type', FieldType.TYPE_ID_REFERENCE],
]);

export const fieldAttributesMap = new Map([
  ['_order', FieldType._ORDER],
  ['componentType', FieldType.COMPONENT_TYPE],
  ['createdByEmail', FieldType.CREATED_BY_EMAIL],
  ['createdByName', FieldType.CREATED_BY_NAME],
  ['defaultValue', FieldType.DEFAULT_VALUE],
  ['description', FieldType.FIELD_DESCRIPTION],
  ['global', FieldType.GLOBAL],
  ['globalref', FieldType.GLOBALREF],
  ['label', FieldType.LABEL],
  ['lastModifiedByEmail', FieldType.LAST_MODIFIED_BY_EMAIL],
  ['lastModifiedByName', FieldType.LAST_MODIFIED_BY_NAME],
  ['model', FieldType.MODEL],
  ['numberFormatOptions', FieldType.NUMBER_FORMAT_OPTIONS],
  ['calculatedFieldSettings', FieldType.TRANSFORMATIONS],
  ['referenceType', FieldType.REFERENCE_TYPE],
  ['type', FieldType.FIELD_TYPE],
  ['populateMethod', FieldType.POPULATE_METHOD],
]);
export const fieldTypeMap = new Map([
  [APIFieldType.CHECKBOX, FieldType.CHECKBOX],
  [APIFieldType.DATE_ONLY_RANGE, FieldType.DATE_ONLY_RANGE],
  [APIFieldType.DATE_TIME_RANGE, FieldType.DATE_TIME_RANGE],
  [APIFieldType.DATE_ONLY, FieldType.DATE_ONLY],
  [APIFieldType.DATE_TIME, FieldType.DATE_TIME],
  [APIFieldType.EMAIL, FieldType.EMAIL],
  [APIFieldType.LIST, FieldType.LIST],
  [APIFieldType.NUMBER, FieldType.NUMBER],
  [APIFieldType.SELECT_MULTIPLE_LIST, FieldType.SELECT_MULTIPLE_LIST],
  [APIFieldType.TEXT, FieldType.TEXT],
  [APIFieldType.TEXT_AREA, FieldType.TEXT_AREA],
  [APIFieldType.URL, FieldType.URL],
  [APIFieldType.USER, FieldType.USER],
  [APIFieldType.FILE, FieldType.FILE],
]);

export const componentTypeAttributesMap = new Map([
  ['children', FieldType.COMPONENT_TYPE_CHILDREN],
  ['color', FieldType.COLOR],
  ['icon', FieldType.ICON],
  ['id', FieldType.ID],
  ['image', FieldType.IMAGE],
  ['index', FieldType.COMPONENT_TYPE_INDEX],
  ['level', FieldType.COMPONENT_TYPE_LEVEL],
  ['name', FieldType.NAME],
  ['returnsValue', FieldType.RETURNS_VALUE],
  ['parent', FieldType.COMPONENT_TYPE_PARENT],
  ['shape', FieldType.SHAPE],
  ['standard', FieldType.COMPONENT_TYPE_STANDARD],
  ['type', FieldType.COMPONENT_TYPE_TYPE],
]);

export const referenceTypeAttributesMap = new Map([
  ['id', FieldType.ID],
  ['color', FieldType.COLOR],
  ['returnsValue', FieldType.RETURNS_VALUE],
  ['line', FieldType.REFERENCE_TYPE_LINE],
  ['lineBeginning', FieldType.REFERENCE_TYPE_LINE_BEGINNING],
  ['lineEnding', FieldType.REFERENCE_TYPE_LINE_ENDING],
  ['index', FieldType.REFERENCE_TYPE_INDEX],
  ['name', FieldType.NAME],
  ['svgStyle', FieldType.TEXT],
  ['hasCardinality', FieldType.HAS_CARDINALITY],
]);

export const modelAttributesMap = new Map([
  ['blankTemplate', FieldType.BLANK_TEMPLATE],
  ['category', FieldType.CATEGORY],
  ['createdByEmail', FieldType.CREATED_BY_EMAIL],
  ['createdByName', FieldType.CREATED_BY_NAME],
  ['createdFromTemplate', FieldType.CREATED_FROM_TEMPLATE],
  ['defaultViews', FieldType.DEFAULT_VIEWS],
  ['flexible', FieldType.FLEXIBLE],
  ['lastModifiedByEmail', FieldType.LAST_MODIFIED_BY_EMAIL],
  ['lastModifiedByName', FieldType.LAST_MODIFIED_BY_NAME],
  ['referenceTypes', FieldType.REFERENCE_TYPES],
  ['root', FieldType.ROOT],
  ['startView', FieldType.START_VIEW],
  ['useAsTemplate', FieldType.USE_AS_TEMPLATE],
]);

export const workspaceAttributesMap = new Map([
  ['startView', FieldType.START_VIEW],
  ['defaultPerspective', FieldType.DEFAULT_PERSPECTIVE],
  ['defaultSort', FieldType.DEFAULT_SORT],
]);

export const tagAttributesMap = new Map([
  ['description', FieldType.DESCRIPTION],
  ['rootWorkspace', FieldType.ROOT_WORKSPACE],
  ['components', FieldType.COMPONENTS_LIST],
  ['references', FieldType.REFERENCE_LIST],
]);
